var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("支付成功，"+_vm._s(_vm.second)+"秒后将关闭当前页面")])}
var staticRenderFns = []

export { render, staticRenderFns }